export const Trim = (data) => {
    const maxLength = 25;
    let trimmeddata = data.length > maxLength
      ? data.substring(0, maxLength).trim() + '...'
      : data;
  
    return trimmeddata;
};